import { useMemo } from "react";

import { Experiments } from ".";

/**
 * Represents a hook to retrieve a feature gate.
 * @param name The name of the feature gate.
 * @returns Boolean indicating if the feature gate is enabled.
 */
export const useFeatureGate = (name: string) => {
    return useMemo(() => Experiments.checkGate(name), [name]);
};
